/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { Capacitor } from '@capacitor/core';
import { SafeArea } from 'capacitor-plugin-safe-area';

if (Capacitor.isNativePlatform()) {
  document.documentElement.style.setProperty('--bottom-nav-safe-area-fallback', '0px');
  document.documentElement.style.setProperty('--bottom-nav-extra-content-padding', '0px');

  if (Capacitor.getPlatform() === 'ios') {
    SafeArea.getStatusBarHeight().then(({ statusBarHeight }) => {
      document.documentElement.style.setProperty(
        `--safe-area-statusbarHeight`,
        `${statusBarHeight}px`,
      );
    });

    SafeArea.addListener('safeAreaChanged', (data) => {
      const { insets } = data;
      for (const [key, value] of Object.entries(insets)) {
        document.documentElement.style.setProperty(`--safe-area-${key}`, `${value}px`);
      }
    });
  }
}
